import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { useEffect, useRef } from "react"
import { fetchStoreGeo, fetchStoreStatistics, selectCurrentPartner, selectEndDate, selectStartDate, selectStoreGeoFirstLoad, selectStoreStatisticsFirstLoad } from "../model"
import { MapFilters } from "./map-filters"
import { Map } from './map'
import { InspectStoreModal } from "./inspect-store-modal"

export const PartnerMapPage = () => {
    const isFirstRender = useRef(true)
    const storeGeoFirstLoad = useAppSelector(selectStoreGeoFirstLoad)
    const storeStatisticsFirstLoad = useAppSelector(selectStoreStatisticsFirstLoad)
    const startDate = useAppSelector(selectStartDate)
    const endDate = useAppSelector(selectEndDate)
    const partnerId = useAppSelector(selectCurrentPartner)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchStoreStatistics())
        }
    }, [startDate, endDate, partnerId])

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchStoreGeo())
        }
    }, [partnerId])

    useEffect(() => {
        if (storeGeoFirstLoad) {
            dispatch(fetchStoreGeo())
        }
        if (storeStatisticsFirstLoad) {
            dispatch(fetchStoreStatistics())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Торговые точки" />
            <div className="flexbox">
                <PageSubtitle title="Карта" />
                <MapFilters />
                <Map />
            </div>
            <InspectStoreModal />
        </div>
    )
}